import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { AuthenitcatedUser } from '@modules/auth/models/user-auth.model';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { isNil, merge } from 'lodash';
import { Role } from '@shared/models/role';

export class SessionKey {
    static CURRENT_SELECT_LANG = 'CURRENT_SELECT_LANG';
    static UKEY = 'UKEY';
    static ROLE = 'ROLE';
}

@Injectable({
    providedIn: 'root'
})
export class SessionService {
    private currentUserSubject: BehaviorSubject<any>;
    private currentLangSubject: Subject<string>;
    private userRoleSubject: Subject<string>;
    currentUser$: Observable<AuthenitcatedUser>;

    constructor(private localize: LocalizeRouterService) {
        const storedUser = JSON.parse(localStorage.getItem('currentUser')) as AuthenitcatedUser;
        let authenticatedUser = new AuthenitcatedUser();
        authenticatedUser = merge(authenticatedUser, storedUser);

        this.currentUserSubject = new BehaviorSubject<AuthenitcatedUser>(authenticatedUser);
        this.currentUser$ = this.currentUserSubject.asObservable();
        this.currentLangSubject = new Subject<any>();
        this.userRoleSubject = new Subject<any>();
    }

    get authenticatedUser(): AuthenitcatedUser {
        return !this.currentUserSubject.value ? null : this.currentUserSubject.value;
    }

    saveCurrentLang(language: string): void {
        localStorage.setItem(SessionKey.CURRENT_SELECT_LANG, language);
        this.currentLangSubject.next(language);
    }

    saveUserId(uId): void {
        localStorage.setItem(SessionKey.UKEY, uId);
    }

    get userId(): string {
        return localStorage.getItem(SessionKey.UKEY);
    }
    saveUserRole(uId): void {
        localStorage.setItem(SessionKey.ROLE, uId);
        this.userRoleSubject.next(uId);
    }

    get userRole(): string {
        return localStorage.getItem(SessionKey.ROLE);
    }

    get userRole$(): Observable<string> {
        return this.userRoleSubject.asObservable();
    }

    get currentLang$(): Observable<string> {
        return this.currentLangSubject.asObservable();
    }

    get currentLang(): string {
        const lang = localStorage.getItem(SessionKey.CURRENT_SELECT_LANG);
        return !isNil(lang) ? lang : this.localize.parser.currentLang;
    }

    getAuthToken(): string {
        return !this.authenticatedUser ? null : this.authenticatedUser.access_token;
    }

    saveSesstion(userInfor: AuthenitcatedUser): void {
        let authenticatedUser = new AuthenitcatedUser();
        authenticatedUser = merge(authenticatedUser, userInfor);

        localStorage.setItem('currentUser', JSON.stringify(authenticatedUser));
        this.currentUserSubject.next(authenticatedUser);
    }

    destroySession(): void {
        localStorage.clear();
        this.currentUserSubject.next(null);
    }

    isAdmin(role: Role): boolean {
        return this.userRole && this.userRole.startsWith(role);
    }
}
